






































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import { roles } from "@/config/roles";
import presenceItems from "@/config/presence-items";

import { getElegantDateString, getLocaleStringFromDateStringWithOptions } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";


/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";
import PresenceItem from "@/components/composition/components/PresenceItem.vue";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { Guid } from "@/domain/guid";
import { SignupState } from "@/api/compositions/signup-state";


export interface SetSignupStateForm {
	signupState: SignupState | null;
	characterID: Guid | null;
	comment: string | null;
	role: string | null;
}

const defaultSignupPayload: SetSignupStateForm = {
	signupState: null,
	characterID: null,
	comment: "",
	role: null
};

/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Signups' view page.
 */
@Component({
	components: {
		DataFetcher,
		PresenceItem,
		GroupCard
	}
})
export default class SignupsViewPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	getElegantDateString = getElegantDateString;
	getLocaleStringFromDateStringWithOptions = getLocaleStringFromDateStringWithOptions;

	teamUrl = teamUrl;

	presenceItems = presenceItems;

	/// Props

	/// Attributes
	isLoading = false;
	compositionGroup: GetOneCompositionGroupResponse | null = null;
	payload: SetSignupStateForm = {
		...defaultSignupPayload
	};

	showOptions: number[] = [];

	get showUnknowns() {
		return this.showOptions.includes(0);
	}

	get headers() {
		return [
			{
				text: this.$t("composition.characters"),
				value: "characters",
				align: "left",
				sortable: false
			},
			{
				text: this.$t("composition.presence"),
				value: "signupState",
				align: "left",
				class: "collapsing"
			},
			{
				text: this.$t("composition.lastStateChangedDate"),
				value: "lastStateChangedDate",
				align: "left",
				class: "collapsing"
			},
			{
				text: this.$t("composition.comment"),
				value: "comment",
				align: "left",
				class: "collapsing"
			}
		];
	}

	// Pagination
	page = 1;
	pageCount = 0;

	get activeSignups() {
		return this.compositionGroup?.signups ?? null;
	}


	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get canManageCompositions() {
		return this.hasPermission(roles.MANAGE_COMPOSITIONS);
	}

	get isPayloadValid() {
		return this.payload.signupState != null;
	}

	/// Methods
	async created() {
	}

	async fetchCurrentCompositionGroup() {
		await this.fetchCompositionGroup(this.$route.params.id);
	}

	async fetchCompositionGroup(id: string) {
		this.compositionGroup = await compositionsAPI.fetchCompositionGroup(id, true, false, this.showUnknowns);
		const mySignup = this.compositionGroup.mySignup;
		if (mySignup) {
			this.payload.signupState = mySignup.signupState;
			this.payload.characterID = mySignup.character ? mySignup.character.id : null;
			this.payload.comment = mySignup.comment;
			this.payload.role = mySignup.role;
		}
		else {
			this.payload = {
				...defaultSignupPayload
			};
		}
	}

	async handleSubmitClick() {
		if (this.compositionGroup == null) {
			return;
		}

		if (this.payload.signupState == null) {
			return;
		}

		this.isLoading = true;
		try {
			await compositionsAPI.setSignupState(this.compositionGroup.id, {
				signupState: this.payload.signupState,
				characterID: this.payload.characterID,
				comment: this.payload.comment,
				role: this.payload.role
			});
			await this.fetchCurrentCompositionGroup();
			this.$snackbar.openInfo(this.$t("snackbar.save_success"));
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleToggleLockedButtonClick() {
		this.isLoading = true;
		try {
			if (this.compositionGroup != null) {

				await compositionsAPI.toggleLocked(this.compositionGroup.id);
				await this.fetchCurrentCompositionGroup();
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleToggleShowUnknownsClick() {
		this.isLoading = true;
		try {
			if (this.compositionGroup != null) {
				if (this.showOptions.includes(0)) {
					this.showOptions = this.showOptions.filter(x => x !== 0);
				}
				else {
					this.showOptions.push(0);
				}
				await this.fetchCurrentCompositionGroup();
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
